import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        classifiers: '='
    },
    template: `
        <div class="modal-header" id="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'courses.external.Add external participation' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <div class="form">
                    <form-row error="vm.form.errors.userId">
                        <label class="label">{{ 'courses.external.Employee' | translate }} *</label>
                        <div class="items">
                            <tags-input
                                ng-model="vm.employees"
                                display-property="displayName"
                                key-property="id"
                                replace-spaces-with-dashes="false"
                                add-from-autocomplete-only="true"
                                allowLeftoverText="false"
                                placeholder="{{'filter.Find an employee' | translate}}"
                                add-on-enter="true"
                                max-tags="20"
                                on-tag-adding="vm.onTagAdding($tag)">
                                <auto-complete
                                    source="vm.queryUsers($query)"
                                    display-property="customName">
                                </auto-complete>
                            </tags-input>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.trainingType">
                        <label class="label">{{ 'course.Training type' | translate }} *</label>
                        <div class="items">
                           <select ng-model="vm.form.model.trainingType" class="form-control">
                                <option value="{{ vm.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.TRAINING }}">
                                    {{ vm.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.LABELS.TRAINING }}
                                </option>
                                <option value="{{ vm.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.CONFERENCE }}">
                                    {{ vm.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.LABELS.CONFERENCE }}
                                </option>
                                <option value="{{ vm.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.ONLINE_COURSE }}">
                                    {{ vm.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.LABELS.ONLINE_COURSE }}
                                </option>
                            </select>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.courseName">
                        <label class="label">{{ 'courses.Training name' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.courseName" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.trainingLink" ng-if="vm.showTrainingLink()">
                        <label class="label">{{ 'course.Training link' | translate }}
                            <span ng-if="vm.form.model.trainingType !== vm.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.TRAINING">*</span>
                        </label>
                        <div class="items">
                            <input ng-model="vm.form.model.trainingLink" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row>
                        <label class="label">{{ 'course.Automated time calculation' | translate }}</label>
                        <div class="items">
                            <label class="switch01">
                                <input
                                  type="checkbox"
                                  name="r06"
                                  ng-model="vm.automaticTimeCalculation"
                                  ng-change="vm.saveTimeCalculationToStorage()"
                                  class="ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched">
                                <span>Yes</span>
                            </label>
                        </div>
                    </form-row>
                    <form-row>
                        <label class="label">{{ 'courses.external.Training dates' | translate }} *</label>
                        <div class="items">
                            <ul class="multivalue">
                                <div ng-repeat="(index, courseDate) in vm.courseDates">
                                    <form-row error="vm.form.errors.courseDates[index].startTime || vm.form.errors.courseDates[index].endTime">
                                        <div>
                                            <li>
                                                <datepicker ng-model="courseDate.date" ng-change="vm.calculateDuration()"></datepicker>
                                                <select ng-model="courseDate.startTime" class="ml5 form-control small" ng-change="vm.calculateDuration()">
                                                    <option value="06:00">06:00</option>
                                                    <option value="06:30">06:30</option>
                                                    <option value="07:00">07:00</option>
                                                    <option value="07:30">07:30</option>
                                                    <option value="08:00">08:00</option>
                                                    <option value="08:30">08:30</option>
                                                    <option value="09:00">09:00</option>
                                                    <option value="09:30">09:30</option>
                                                    <option value="10:00">10:00</option>
                                                    <option value="10:30">10:30</option>
                                                    <option value="11:00">11:00</option>
                                                    <option value="11:30">11:30</option>
                                                    <option value="12:00">12:00</option>
                                                    <option value="12:30">12:30</option>
                                                    <option value="13:00">13:00</option>
                                                    <option value="13:30">13:30</option>
                                                    <option value="14:00">14:00</option>
                                                    <option value="14:30">14:30</option>
                                                    <option value="15:00">15:00</option>
                                                    <option value="15:30">15:30</option>
                                                    <option value="16:00">16:00</option>
                                                    <option value="16:30">16:30</option>
                                                    <option value="17:00">17:00</option>
                                                    <option value="17:30">17:30</option>
                                                    <option value="18:00">18:00</option>
                                                    <option value="18:30">18:30</option>
                                                    <option value="19:00">19:00</option>
                                                    <option value="19:30">19:30</option>
                                                    <option value="20:00">20:00</option>
                                                    <option value="20:30">20:30</option>
                                                    <option value="21:00">21:00</option>
                                                    <option value="21:30">21:30</option>
                                                    <option value="22:00">22:00</option>
                                                    <option value="22:30">22:30</option>
                                                    <option value="23:00">23:00</option>
                                                    <option value="23:30">23:30</option>
                                                </select>
                                                <span class="text" style="margin-right: 8px">-</span>
                                                <select ng-model="courseDate.endTime" class="ml5 form-control small" ng-change="vm.calculateDuration()">
                                                    <option value="06:00">06:00</option>
                                                    <option value="06:30">06:30</option>
                                                    <option value="07:00">07:00</option>
                                                    <option value="07:30">07:30</option>
                                                    <option value="08:00">08:00</option>
                                                    <option value="08:30">08:30</option>
                                                    <option value="09:00">09:00</option>
                                                    <option value="09:30">09:30</option>
                                                    <option value="10:00">10:00</option>
                                                    <option value="10:30">10:30</option>
                                                    <option value="11:00">11:00</option>
                                                    <option value="11:30">11:30</option>
                                                    <option value="12:00">12:00</option>
                                                    <option value="12:30">12:30</option>
                                                    <option value="13:00">13:00</option>
                                                    <option value="13:30">13:30</option>
                                                    <option value="14:00">14:00</option>
                                                    <option value="14:30">14:30</option>
                                                    <option value="15:00">15:00</option>
                                                    <option value="15:30">15:30</option>
                                                    <option value="16:00">16:00</option>
                                                    <option value="16:30">16:30</option>
                                                    <option value="17:00">17:00</option>
                                                    <option value="17:30">17:30</option>
                                                    <option value="18:00">18:00</option>
                                                    <option value="18:30">18:30</option>
                                                    <option value="19:00">19:00</option>
                                                    <option value="19:30">19:30</option>
                                                    <option value="20:00">20:00</option>
                                                    <option value="20:30">20:30</option>
                                                    <option value="21:00">21:00</option>
                                                    <option value="21:30">21:30</option>
                                                    <option value="22:00">22:00</option>
                                                    <option value="22:30">22:30</option>
                                                    <option value="23:00">23:00</option>
                                                    <option value="23:30">23:30</option>
                                                </select>
                                                <a class="btn delete" ng-if="index !== 0" ng-click="vm.removeCourseDate(index)">{{ 'general.Remove' | translate }}</a>
                                            </li>
                                            <li><form-row-error></form-row-error></li>
                                        </div>
                                    </form-row>
                                </div>
                                <p class="desc error-text" ng-if="vm.form.errors.courseDatesLimit">{{ vm.form.errors.courseDatesLimit }}</p>
                                <a class="btn add" ng-click="vm.addCourseDate()">{{ 'courses.external.Add another day' | translate }}</a>
                            </ul>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.duration || vm.form.errors.durationType" ng-if="!vm.automaticTimeCalculation">
                        <label class="label">{{ 'courses.external.Duration' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.duration" class="form-control small" ng-change="vm.checkDurationError()">
                            <select ng-model="vm.form.model.durationType" class="form-control small">
                                <option value="HOURS">{{ 'courses.external.Hours' | translate }}</option>
                                <option value="AHOURS">{{ 'courses.external.Academic hours' | translate }}</option>
                                <option value="DAYS">{{ 'courses.external.Days' | translate }}</option>
                            </select>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.price || vm.form.errors.priceType">
                        <label class="label">{{ 'courses.external.Cost' | translate }} *</label>
                        <div class="items">
                            <input ng-model="vm.form.model.price" class="form-control small">
                            <select ng-model="vm.form.model.priceType" class="form-control small">
                                <option value="{{ vm.COURSE_PRICE_TYPE_ENUM.KEYS.EURO }}">
                                    {{ vm.COURSE_PRICE_TYPE_ENUM.LABELS.EURO }}
                                </option>
                                <option value="{{ vm.COURSE_PRICE_TYPE_ENUM.KEYS.DOLLAR }}">
                                    {{ vm.COURSE_PRICE_TYPE_ENUM.LABELS.DOLLAR }}
                                </option>
                                <option value="{{ vm.COURSE_PRICE_TYPE_ENUM.KEYS.POUND }}">
                                    {{ vm.COURSE_PRICE_TYPE_ENUM.LABELS.POUND }}
                                </option>
                            </select>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row>
                        <label class="label">{{ 'occurrence.Display extra options' | translate }}</label>
                        <div class="items">
                            <label class="switch01">
                                <input
                                  type="checkbox"
                                  name="r05"
                                  ng-model="vm.extra"
                                  ng-change="vm.saveExtraToLocalStorage()"
                                  class="ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched">
                                <span>Yes</span>
                            </label>
                        </div>
                    </form-row>
                    <div ng-if="vm.extra">
                        <form-row error="vm.form.errors.fieldIds">
                            <label class="label">{{ 'courses.external.Training field' | translate }}</label>
                            <div class="items">
                                <select class="form-control" ng-model="vm.fieldId" ng-options="item.id as item.activeI18n.value for item in vm.fields">
                                </select>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.expireDate">
                            <label class="label">{{ 'reports.Expire date' | translate }}</label>
                            <div class="items">
                                <datepicker-api ng-model="vm.form.model.expireDate"></datepicker-api>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.certificateNumber">
                            <label class="label">{{ 'courses.external.participation.Certificate number' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.certificateNumber" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.trainer">
                            <label class="label">{{ 'courses.external.Trainer' | translate }}</label>
                            <div class="items">
                                <input ng-model="vm.form.model.trainer" class="form-control">
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.files">
                            <label class="label">
                                {{ 'courses.external.Files' | translate }}
                                <span class="tooltip-icon"
                                    uib-tooltip="{{ 'courses.external.If needed, add certificates or any other materials for proof' | translate }}"
                                    tooltip-placement="top-right"
                                >?</span>
                            </label>
                            <div class="items">
                                <input ngf-select="vm.setFiles($files)" ng-model="vm.form.model.files" type="file" multiple />
                                <p ng-repeat="(key, error) in vm.lodash.uniq(vm.form.errors.files)">
                                    {{ 'general.File' | translate }} {{ (key+1) }}: {{ error.file }}
                                </p>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.additionalInfo">
                            <label class="label">{{ 'courses.external.Additional info' | translate }}</label>
                            <div class="items">
                                <textarea ng-model="vm.form.model.additionalInfo" class="form-control"></textarea>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </div>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'courses.external.Add external participation' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $state, lodash, toastr, moment,
                 FormFactory, Upload,
                 ExternalParticipationResource, UserResource,
                 ResponseService,
                 MomentService,
                 ROLE_CODE_ENUM, COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM, CLASSIFIER_ENUM,
                 COURSE_DURATION_TYPE_ENUM, COURSE_PRICE_TYPE_ENUM, COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM,
                 TokenService) {
        this.$translate = $translate;
        this.$state = $state;
        this.lodash = lodash;
        this.toastr = toastr;
        this.moment = moment;
        this.FormFactory = FormFactory;
        this.Upload = Upload;
        this.ExternalParticipationResource = ExternalParticipationResource;
        this.UserResource = UserResource;
        this.ResponseService = ResponseService;
        this.MomentService = MomentService;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.COURSE_DURATION_TYPE_ENUM = COURSE_DURATION_TYPE_ENUM;
        this.COURSE_PRICE_TYPE_ENUM = COURSE_PRICE_TYPE_ENUM;
        this.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM = COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM;
        this.TokenService = TokenService;
        this.showInputError = false;
        this.initFields();
    }

    initFields () {
        this.userId = this.TokenService.getUser().id;
        const extraOptionValue = localStorage.getItem(`${this.userId}_extraOption`);
        const timeCalculations = localStorage.getItem(`${this.userId}_timeCalculation`);
        this.extra = extraOptionValue === 'true';
        this.automaticTimeCalculation = true;
        if (timeCalculations !== null) {
            this.automaticTimeCalculation = timeCalculations === 'true';
        }
        const emptyField = [{ id: null, activeI18n: { value: '' } }];
        const fields = this.classifiers.filter((classifier) => classifier.type === this.CLASSIFIER_ENUM.KEYS.FIELD);
        this.fields = [...emptyField, ...fields];
        this.fieldId = null;
        this.employees = null;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(
            new this.ExternalParticipationResource({
                status: this.COURSE_EXTERNAL_PARTICIPATION_STATUS_TYPE_ENUM.KEYS.CONFIRMED
            })
        );

        this.tooltipTexts = {
            addFile: this.$translate.instant('externalParticipation.To select multiple files please hold the CTRL key when selecting files')
        };

        if (!this.courseDates) {
            this.courseDates = [];
            this.addCourseDate();
        }

        if (!this.form.model.priceType) {
            this.form.model.priceType = 'EURO';
            this.form.model.price = 0;
        }
        if (!this.form.model.durationType) {
            this.form.model.durationType = 'HOURS';
        }
        if (!this.automaticTimeCalculation) {
            this.form.model.duration = 0;
        }
        this.form.model.isSpecificTraining = 1;
    }

    addCourseDate () {
        if (this.courseDates.length >= 20) {
            this.form.errors.courseDatesLimit = this.$translate.instant('courses.external.Course dates limit');
            return;
        }
        const last = [...this.courseDates].pop();
        let newDate;

        if (!last) {
            newDate = new Date();
        }
        else {
            newDate = this.moment(last.date).add(1, 'd').toDate();
        }

        this.courseDates.push({
            date: newDate,
            startTime: '09:00',
            endTime: '17:00'
        });

        this.calculateDuration();
    }

    removeCourseDate (index) {
        this.courseDates.splice(index, 1);
    }

    queryUsers (input) {
        if (input.length < 2) {
            return false;
        }
        const params = {
            name: input,
            externalParticipationUsersOnly: true,
            privilegesCheck: 0,
            pageSize: 0
        };

        return this.UserResource.query(params).$promise.then(users => {
            return users.map((user) => {
                const email = user.primaryEmail ? `${user.primaryEmail}` : this.$translate.instant('courses.external.email not available');
                user.customName = `${user.displayName} (${email})`;
                return user;
            });
        });
    }

    onTagAdding () {
        if (this.employees && this.employees.length >= 20) {
            // Prevent adding the employee more than allowed limit at once
            this.form.errors.userId = this.$translate.instant('courses.external.employee limit');
            return false;
        }
        this.form.errors.userId = null;
        return true;
    }

    saveExtraToLocalStorage () {
        localStorage.setItem(`${this.userId}_extraOption`, this.extra);
    }

    saveTimeCalculationToStorage () {
        if (!this.automaticTimeCalculation) {
            this.form.model.duration = 0;
        }
        localStorage.setItem(`${this.userId}_timeCalculation`, this.automaticTimeCalculation);
    }
    setFiles (files) {
        this.form.model.files = files;
    }

    beforeSave () {
        this.form.model.isSpecificTraining = true;
        this.form.model.isAdminRequest = true;
        this.form.model.courseDates = [];
        this.lodash.forEach(this.courseDates, (courseDate, index) => {
            this.form.model.courseDates[index] = {
                startTime: courseDate.date
                    ? this.MomentService.convertToUtc(this.datetime(courseDate.date, courseDate.startTime))
                    : '',
                endTime: courseDate.date
                    ? this.MomentService.convertToUtc(this.datetime(courseDate.date, courseDate.endTime))
                    : ''
            };
        });
        this.form.model.fieldIds = [];
        if (this.fieldId) {
            this.form.model.fieldIds = [this.fieldId];
        }

        if (this.employees && this.employees.length > 0) {
            this.form.model.userIds = this.lodash.map(this.employees, 'id');
        }

        if (this.automaticTimeCalculation) {
            this.form.model.durationType = 'HOURS';
            this.form.model.duration = this.calculateDuration();
        }
    }

    datetime (date, time) {
        return [this.moment(date).format('YYYY-MM-DD'), [time, '00'].join(':')].join(' ');
    }

    checkDurationError () {
        this.form.errors.duration = '';
        if (!this.automaticTimeCalculation && this.form.model.duration === '') {
            this.form.errors.duration = this.$translate.instant('courses.external.Duration blank');
            return true;
        }
        if (!this.automaticTimeCalculation && this.form.model.duration > 999) {
            this.form.errors.duration = this.$translate.instant('courses.external.Duration upper limit');
            return true;
        }
        return false;
    }

    save () {
        this.beforeSave();
        if (this.checkDurationError()) {
            return;
        }
        this.Upload
            .upload({
                url: `${SEED_CORE.ENV.API_URL}course/external-participation`,
                data: this.form.model,
                method: 'POST'
            })
            .then((response) => {
                const participations = response.data;
                const lastParticipantAdded = participations[participations.length - 1].id;
                this.toastr.success(this.$translate.instant('courses.external.External course participation successfully entered'));
                this.uibModalInstance.dismiss();
                this.$state.go('authorized.courses.participations.detail', { id: lastParticipantAdded });
            }).catch((response) => {
                this.form.invalid = true;
                this.form.saved = false;
                this.form.errors = this.ResponseService.parseErrors(response);
            });
    }

    showTrainingLink () {
        if (this.form.model.trainingType === undefined) {
            return false;
        }

        return [
            this.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.CONFERENCE,
            this.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.ONLINE_COURSE,
            this.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.TRAINING
        ].includes(this.form.model.trainingType);
    }

    showTrainingDates () {
        if (this.form.model.trainingType === undefined) {
            return false;
        }

        return [
            this.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.TRAINING,
            this.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.CONFERENCE
        ].includes(this.form.model.trainingType);
    }

    showTrainingDuration () {
        if (this.form.model.trainingType === undefined) {
            return false;
        }

        return this.form.model.trainingType === this.COURSE_EXTERNAL_PARTICIPATION_TRAINING_TYPE_ENUM.KEYS.ONLINE_COURSE;
    }

    calculateDuration () {
        const dates = [];
        let duration = 0;
        this.lodash.forEach(this.courseDates, (courseDate) => {
            dates.push({
                startTime: courseDate.date
                    ? [this.moment(courseDate.date).format('DD-MM-YYYY'), [courseDate.startTime, '00'].join(':')].join(' ')
                    : '',
                endTime: courseDate.date
                    ? [this.moment(courseDate.date).format('DD-MM-YYYY'), [courseDate.endTime, '00'].join(':')].join(' ')
                    : ''
            });
        });

        if (!this.form.errors.courseDates) {
            this.form.errors.courseDates = [];
        }

        dates.forEach((date, index) => {
            if (date.startTime && date.endTime) {
                const startTimeMoment = this.moment(date.startTime, 'DD-MM-YYYY HH:mm:ss');
                const endTimeMoment = this.moment(date.endTime, 'DD-MM-YYYY HH:mm:ss');

                if (endTimeMoment.isBefore(startTimeMoment)) {
                    if (!this.form.errors.courseDates[index]) {
                        this.form.errors.courseDates[index] = {};
                    }
                    this.form.errors.courseDates[index].startTime = this.$translate.instant('courses.external.time error');
                }
                else {
                    this.form.errors.courseDates[index] = {};
                }
                duration += endTimeMoment.diff(startTimeMoment, 'hours', true);
                if (duration < 0) {
                    duration = 0;
                }
            }
        });

        return duration;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/courses/external/addParticipation/index.js